import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsDepartmentsDepartmentRoute extends Route {
  @service store;

  model({ department_id }) {
    return this.store.findRecord('department', department_id);
  }
}

export default instrumentRoutePerformance(SettingsDepartmentsDepartmentRoute);
